import { groupBy } from '../../../../../util/arrays';

// eslint-disable-next-line camelcase
function iterarSobreCruzamentos(pergunta_principal) {
  // eslint-disable-next-line camelcase
  const cruzamentos = pergunta_principal.alternativas.map((alternativa_principal) => {
    // eslint-disable-next-line camelcase
    const { pergunta_cruzada } = pergunta_principal;

    const data = pergunta_cruzada.alternativas
      // eslint-disable-next-line camelcase
      .map((alternativa_cruzada) => {
        const cruzamento = alternativa_cruzada.cruzamentos[alternativa_principal.id];
        return {
          pergunta_principal,
          alternativa_principal,
          pergunta_cruzada,
          alternativa_cruzada,
          ...cruzamento,
        };
      });

    return data;
  })
    .reduce((reduced, next) => [...reduced, ...next]);

  return cruzamentos;
}

function getLabelFormatter(highestNumberProvider) {
  const timesHigher = 6;

  return (params) => {
    const highest = highestNumberProvider(params);

    if (params.data.value === 0) {
      return '';
    }

    if (Math.round(highest / params.data.value) >= timesHigher) {
      return '';
    }
    return `${params.data.value}%`;
  };
}

export function getLabelFormatterByMap(highestByBarName) {
  return getLabelFormatter((params) => highestByBarName[params.data.subject]);
}

export function getLabelFormatteByHighestValue(highestValue) {
  return getLabelFormatter((params) => highestValue);
}

/**
 * retorna o label formatter correto a ser utilizado de acordo com
 * valuesByBarName.
 *
 * e o que é valuesByBarName?
 *
 * Após processar a pergunta principal, suas alternativas e as alternativas
 * das perguntas cruzadas, O valuesByBarName é um mapa que mapeia o nome da alternativa cruzada
 * para o valor percentual de cada alternativa principal.
 *
 * Como o gráfico em questão é um gráfico de barras onde cada barra é uma pilha
 * de alternativas principais e a barra em si representa a alternativa cruzada,
 * Esta estrutura de dados é utilizada para construir um formatador de labels que saiba quando
 * renderizar a label ou não baseado nos valores das pilhas do gráfico.
 *
 * Como que funciona a loja abaixo:
 *
 * 1. é obtido uma média aritmética da soma do percentual de cada pilha.
 * ex: [25%, 25%, 50%], [40%, 10%, 5%], [25%, 10%, 10%]
 * = (100% + 55% + 45%) / 3 = 63.334%
 *
 * 2. Se a média aritmética for menor do que 70%, é recuperado o maior numero percentual de
 * todas as pilhas. (neste exemplo, seria 50%) e então a estrategia utilizada para renderizar
 * ou não a label é baseada neste único valor "50%". O label formatter faz uma pergunta do tipo,
 * a meu valor percentual é quantas vezes menor do que "50%"? se for, por exemplo, 6 vezes menor,
 * então ele não é renderizado.
 *
 * 3. Se a média aritmética for maior que 70%, significa que todas as pilhas estão niveladas de maneira
 * quase igual, não existe muita variação. Então, diferente da estrategia passada, pra cada pilha é obtido
 * o maior valor e o labelFormatter, na hora de verificar se deve ou não renderizar a label, utiliza
 * o maior valor da pilha que a label faz parte.
 *
 * @param {*} valuesByBarName
 */
function resolveLabelFormatter(valuesByBarName) {
  const barNames = Object.keys(valuesByBarName);

  const allPercents = barNames
    .map((barName) => valuesByBarName[barName])
    .map((values) => values.map((item) => item.percent).reduce((reduced, next) => reduced + next, 0));

  const average = allPercents.reduce((reduced, next) => reduced + next, 0) / allPercents.length;

  /**
   * strategy no. 2
   */
  if (average < 70) {
    const allValues = barNames.map((barName) => {
      const values = valuesByBarName[barName].map((item) => item.percent);
      return values;
    }).reduce((reduced, next) => reduced.concat(next), []);

    const highest = Math.max.apply(null, allValues);
    return getLabelFormatteByHighestValue(highest);
  }

  /**
   * strategy no. 3
   */
  const highestByBarName = barNames.map((barName) => {
    const values = valuesByBarName[barName].map((item) => item.percent);
    const barHighest = Math.max.apply(null, values);
    const entry = {};
    entry[barName] = barHighest;
    return entry;
  })
    .reduce((reduced, next) => ({ ...reduced, ...next }), {});

  return getLabelFormatterByMap(highestByBarName);
}

/**
 * cria um formatador de label baseado na pergunta principal passada
 * e nas perguntas principais (legendas) a serem ignoradas.
 *
 * @param {*} pergunta_principal
 * @param {*} ignoringAlternativasPrincipais
 */
// eslint-disable-next-line camelcase
export function getLabelFormatterByPerguntasPrincipal(pergunta_principal, ignoringAlternativasPrincipais = []) {
  const alternativasCruzadasValue = iterarSobreCruzamentos(pergunta_principal)
    .filter((cruzamento) => {
      const currentAlternativaPrincipal = cruzamento.alternativa_principal;
      const ignorado = !ignoringAlternativasPrincipais.includes(currentAlternativaPrincipal.enunciado);
      return ignorado;
    })
    .map((cruzamento) => {
      // eslint-disable-next-line camelcase
      const { alternativa_cruzada } = cruzamento;
      // eslint-disable-next-line camelcase
      const { enunciado } = alternativa_cruzada;
      return {
        bar: enunciado,
        value: cruzamento.resultado_numerico,
        percent: cruzamento.resultado_percentual,
      };
    });

  const valuesByBarName = groupBy(alternativasCruzadasValue, 'bar');
  return resolveLabelFormatter(valuesByBarName);
}
